import * as React from "react";

function SvgGooglePlay() {
  return (
    <svg
      width="151"
      height="44"
      viewBox="0 0 151 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_86_15656)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M145.405 44H5.59465C2.5112 44 0 41.5202 0 38.5V5.5C0 2.46883 2.5112 0 5.59465 0H145.405C148.486 0 151 2.46883 151 5.5V38.5C151 41.5202 148.486 44 145.405 44Z"
          fill="black"
        />
        <path
          d="M79.5475 14.5553C78.5391 14.5553 77.6891 14.207 77.0168 13.5212C76.3501 12.8546 75.9779 11.9356 75.9946 10.9975C75.9946 9.99625 76.339 9.14862 77.0168 8.47655C77.6863 7.79076 78.5363 7.44238 79.5447 7.44238C80.542 7.44238 81.392 7.79076 82.0754 8.47655C82.7532 9.17056 83.0976 10.0182 83.0976 10.9975C83.0865 12.0015 82.7421 12.8491 82.0754 13.5184C81.4059 14.2097 80.5559 14.5553 79.5475 14.5553ZM49.5436 14.5553C48.5575 14.5553 47.7019 14.2125 47.0018 13.5349C46.3074 12.8601 45.9546 12.007 45.9546 11.0002C45.9546 9.9935 46.3074 9.14039 47.0018 8.46557C47.688 7.78802 48.5436 7.44513 49.5436 7.44513C50.0325 7.44513 50.5075 7.54114 50.9631 7.7359C51.4103 7.92518 51.7742 8.18303 52.0437 8.49849L52.1104 8.57804L51.3576 9.30772L51.2798 9.21719C50.8548 8.71794 50.2853 8.4738 49.5325 8.4738C48.8602 8.4738 48.2741 8.70971 47.7908 9.17605C47.3046 9.64512 47.0574 10.2596 47.0574 11.003C47.0574 11.7464 47.3046 12.3608 47.7908 12.8299C48.2741 13.2962 48.8602 13.5322 49.5325 13.5322C50.2492 13.5322 50.852 13.2962 51.3215 12.8299C51.5992 12.5556 51.7715 12.1716 51.8326 11.686H49.4186V10.6601H52.8687L52.8826 10.7534C52.9076 10.9262 52.9326 11.1045 52.9326 11.2691C52.9326 12.2154 52.6437 12.9808 52.0715 13.5459C51.4215 14.2152 50.5714 14.5553 49.5436 14.5553ZM89.4367 14.41H88.3728L85.1144 9.26109L85.1421 10.1883V14.4072H84.0782V7.59051H85.2921L85.3255 7.64263L88.3895 12.4925L88.3617 11.5681V7.59051H89.4367V14.41ZM71.5528 14.41H70.4749V8.61645H68.6054V7.59051H73.4195V8.61645H71.55V14.41H71.5528ZM67.7276 14.41H66.6526V7.59051H67.7276V14.41ZM61.6857 14.41H60.6107V8.61645H58.7412V7.59051H63.5552V8.61645H61.6857V14.41ZM58.0606 14.399H53.9382V7.59051H58.0606V8.61645H55.016V10.4873H57.7634V11.5022H55.016V13.3731H58.0606V14.399ZM77.8058 12.8162C78.2863 13.2908 78.8697 13.5294 79.5475 13.5294C80.2447 13.5294 80.8142 13.2962 81.2892 12.8162C81.7615 12.3499 82.0004 11.7381 82.0004 11.0002C82.0004 10.2623 81.7615 9.64787 81.292 9.18428C80.8114 8.70971 80.2253 8.47106 79.5503 8.47106C78.853 8.47106 78.2836 8.70423 77.8113 9.18428C77.3391 9.65061 77.1002 10.2623 77.1002 11.0002C77.1002 11.7381 77.3363 12.3526 77.8058 12.8162Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M75.8948 23.9314C73.2697 23.9314 71.1418 25.8982 71.1418 28.6111C71.1418 31.2994 73.2836 33.2909 75.8948 33.2909C78.5199 33.2909 80.6477 31.3104 80.6477 28.6111C80.6477 25.8982 78.5199 23.9314 75.8948 23.9314ZM75.8948 31.4366C74.4586 31.4366 73.2225 30.2625 73.2225 28.6002C73.2225 26.9131 74.4614 25.7638 75.8948 25.7638C77.3309 25.7638 78.5671 26.9131 78.5671 28.6002C78.5699 30.2735 77.3309 31.4366 75.8948 31.4366ZM65.5249 23.9314C62.8999 23.9314 60.772 25.8982 60.772 28.6111C60.772 31.2994 62.9137 33.2909 65.5249 33.2909C68.15 33.2909 70.2779 31.3104 70.2779 28.6111C70.2779 25.8982 68.1473 23.9314 65.5249 23.9314ZM65.5249 31.4366C64.0888 31.4366 62.8526 30.2625 62.8526 28.6002C62.8526 26.9131 64.0916 25.7638 65.5249 25.7638C66.9611 25.7638 68.1973 26.9131 68.1973 28.6002C68.1973 30.2735 66.9611 31.4366 65.5249 31.4366ZM53.1856 25.3605V27.3411H57.9997C57.8524 28.452 57.4802 29.2722 56.9107 29.8346C56.2052 30.5313 55.1162 31.2885 53.1967 31.2885C50.2383 31.2885 47.9243 28.9294 47.9243 26.0079C47.9243 23.0865 50.2383 20.7274 53.1967 20.7274C54.794 20.7274 55.9579 21.3501 56.8218 22.1456L58.2441 20.7411C57.0441 19.6054 55.4468 18.7358 53.2078 18.7358C49.1493 18.7358 45.7437 22.0002 45.7437 25.9969C45.7437 30.0047 49.1466 33.258 53.2078 33.258C55.3996 33.258 57.0441 32.5503 58.3441 31.2171C59.6692 29.9087 60.0886 28.0625 60.0886 26.573C60.0886 26.1094 60.0525 25.6924 59.9775 25.3386H53.1828C53.1856 25.3358 53.1856 25.3605 53.1856 25.3605ZM103.657 26.9022C103.26 25.8515 102.06 23.9204 99.5984 23.9204C97.1595 23.9204 95.1316 25.8159 95.1316 28.6002C95.1316 31.2281 97.1372 33.28 99.8346 33.28C102.001 33.28 103.262 31.9715 103.782 31.2034L102.174 30.1391C101.64 30.9209 100.898 31.4338 99.8457 31.4338C98.7817 31.4338 98.0373 30.9565 97.5428 30.0156L103.879 27.4234C103.879 27.4261 103.657 26.9022 103.657 26.9022ZM97.1956 28.4658C97.1456 26.658 98.6178 25.7391 99.6707 25.7391C100.501 25.7391 101.193 26.1423 101.429 26.7294L97.1956 28.4658ZM92.0482 33.0002H94.1288V19.2516H92.0482V33.0002ZM88.6314 24.971H88.5564C88.0869 24.4196 87.1952 23.9204 86.0563 23.9204C83.6923 23.9204 81.5144 25.975 81.5144 28.6139C81.5144 31.2418 83.6812 33.2717 86.0563 33.2717C87.1813 33.2717 88.0869 32.7698 88.5564 32.2074H88.6314V32.8795C88.6314 34.6653 87.6647 35.6281 86.1063 35.6281C84.8312 35.6281 84.0395 34.7229 83.7173 33.9658L81.9089 34.7119C82.4284 35.9463 83.8145 37.4742 86.1035 37.4742C88.5425 37.4742 90.6092 36.056 90.6092 32.5969V24.2002H88.6425V24.971C88.6453 24.971 88.6314 24.971 88.6314 24.971ZM86.2424 31.4366C84.8062 31.4366 83.6062 30.2515 83.6062 28.6139C83.6062 26.9625 84.8062 25.7665 86.2424 25.7665C87.6647 25.7665 88.7675 26.9762 88.7675 28.6139C88.7814 30.2515 87.6674 31.4366 86.2424 31.4366ZM113.399 19.2516H108.424V33.0002H110.504V27.7937H113.402C115.705 27.7937 117.969 26.1451 117.969 23.5281C117.969 20.9112 115.713 19.2516 113.399 19.2516ZM113.46 25.8735H110.502V21.1553H113.46C115.018 21.1553 115.899 22.4254 115.899 23.5144C115.899 24.5924 115.007 25.8735 113.46 25.8735ZM126.308 23.9067C124.797 23.9067 123.238 24.5678 122.594 26.0079L124.438 26.765C124.835 26.0079 125.563 25.7501 126.333 25.7501C127.411 25.7501 128.5 26.3865 128.525 27.5221V27.6675C128.152 27.459 127.336 27.1408 126.358 27.1408C124.366 27.1408 122.347 28.2161 122.347 30.2323C122.347 32.0785 123.98 33.2635 125.799 33.2635C127.197 33.2635 127.966 32.6408 128.447 31.9194H128.522V32.9837H130.527V27.7169C130.527 25.2645 128.683 23.9067 126.308 23.9067ZM126.047 31.4366C125.366 31.4366 124.413 31.1074 124.413 30.2625C124.413 29.1982 125.602 28.7949 126.616 28.7949C127.533 28.7949 127.966 28.9897 128.511 29.2585C128.361 30.4929 127.305 31.4256 126.047 31.4366ZM137.844 24.2002L135.455 30.1638H135.38L132.905 24.2002H130.666L134.38 32.5366L132.264 37.1698H134.43L140.144 24.2002H137.844ZM119.116 33.0002H121.196V19.2516H119.116V33.0002Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6226 8.28696C11.3004 8.62985 11.1143 9.15379 11.1143 9.83957V34.163C11.1143 34.8488 11.3004 35.3727 11.6337 35.7019L11.7198 35.776L25.5203 22.1481V21.8436L11.7087 8.21289L11.6226 8.28696Z"
          fill="url(#paint0_linear_86_15656)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.1122 26.7044L25.5093 22.159V21.8408L30.1122 17.2954L30.2122 17.3558L35.6569 20.4116C37.2153 21.2785 37.2153 22.7104 35.6569 23.5882L30.2122 26.644L30.1122 26.7044Z"
          fill="url(#paint1_linear_86_15656)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2121 26.6441L25.5092 22L11.6226 35.713C12.1309 36.2506 12.9837 36.311 13.9365 35.787L30.2121 26.6441Z"
          fill="url(#paint2_linear_86_15656)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.2121 17.3557L13.9365 8.22651C12.9837 7.68886 12.1281 7.76292 11.6226 8.30058L25.5092 21.9998L30.2121 17.3557Z"
          fill="url(#paint3_linear_86_15656)"
        />
        <path
          opacity="0.2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.1123 26.5454L13.9478 35.6142C13.045 36.1272 12.2394 36.0915 11.7199 35.6252L11.6338 35.7102L11.7199 35.7843C12.2394 36.2479 13.045 36.2863 13.9478 35.7733L30.2234 26.6442L30.1123 26.5454Z"
          fill="black"
        />
        <path
          opacity="0.12"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.6572 23.4292L30.0986 26.5454L30.1986 26.6441L35.6433 23.5883C36.4239 23.1494 36.8072 22.5733 36.8072 22C36.76 22.5267 36.3627 23.0259 35.6572 23.4292Z"
          fill="black"
        />
        <path
          opacity="0.25"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.9366 8.38601L35.6568 20.5711C36.3624 20.9633 36.7596 21.4763 36.8208 22.0002C36.8208 21.4269 36.4374 20.8509 35.6568 20.412L13.9366 8.22691C12.3782 7.34636 11.1143 8.08153 11.1143 9.83988V9.99898C11.1143 8.23788 12.3782 7.51644 13.9366 8.38601Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_86_15656"
          x1="24.2825"
          y1="9.57715"
          x2="2.21372"
          y2="15.5319"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00A0FF" />
          <stop offset="0.00657" stopColor="#00A1FF" />
          <stop offset="0.2601" stopColor="#00BEFF" />
          <stop offset="0.5122" stopColor="#00D2FF" />
          <stop offset="0.7604" stopColor="#00DFFF" />
          <stop offset="1" stopColor="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_86_15656"
          x1="37.6892"
          y1="21.9999"
          x2="10.7355"
          y2="21.9999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE000" />
          <stop offset="0.4087" stopColor="#FFBD00" />
          <stop offset="0.7754" stopColor="#FFA500" />
          <stop offset="1" stopColor="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_86_15656"
          x1="27.6548"
          y1="24.5271"
          x2="10.2364"
          y2="54.2151"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_86_15656"
          x1="8.12576"
          y1="0.196501"
          x2="15.8968"
          y2="13.4555"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#32A071" />
          <stop offset="0.0685" stopColor="#2DA771" />
          <stop offset="0.4762" stopColor="#15CF74" />
          <stop offset="0.8009" stopColor="#06E775" />
          <stop offset="1" stopColor="#00F076" />
        </linearGradient>
        <clipPath id="clip0_86_15656">
          <rect width="151" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgGooglePlay;
